

import Box from "@mui/material/Box";

import { Swiper, SwiperSlide } from 'swiper/react'

import 'swiper/css';
import 'swiper/css/navigation';
import "./style.css"

import { Navigation } from "swiper";
import Imagen1 from "../../assets/default-product.png";
import ReactImageFallback from "react-image-fallback";
import React from 'react';
import useStyles from './style';

const SwiperImg = ({ imagenes = [] }) => {
  const { classes } = useStyles();
  return (
    <Box className={classes.swiper}>
      <Swiper
        slidesPerView={1}
        spaceBetween={30}
        pagination={{ clickable: true }}
        navigation
        modules={[Navigation]}
      >
        {imagenes.length >= 1
          ? imagenes.map((image, index) => (
            <SwiperSlide key={index}>
              <ReactImageFallback src={image.url} className={classes.media} alt="catalogue" fallbackImage={Imagen1} />
            </SwiperSlide>
          ))
          : <SwiperSlide>
            <img src={Imagen1} className={classes.media} alt="catalogue" />
          </SwiperSlide>
        }
      </Swiper>
    </Box>
  );
}

export default SwiperImg